<template>
  <div style="margin-top: -15px; margin-bottom: 15px;">
    <div class="header-item last-mile-f-right" v-if="enableSaveButton">
      <div class="btn-inline">
        <Button size="mini" type="text" class="ml-0" @click="cancelChanges">{{ $t('MDM_CANCEL') }}</Button>
        <Button size="mini" type="primary" class="ml-0" @click="saveDropoffDetails(false)">{{ $t('SAVE')}}</Button>
      </div>
    </div>
    <div class="popover-custom no-border with-shadow" placement="topright" v-if="showConfirmationBox">
      <div class="popover-body bg-white w-300">
        <span class="warning-text"> {{ $t('LOGIN_WARNING') }} </span>
        <svgicon name="icon-warning-circle" class="text-red" width="12" height="13" />
        <p>
          {{ $t('LAST_DROP_UNDELIVERED_WARNING') }}
        </p>
        <p class="content_text"> {{$t('DO_YOU_WANT_TO_PROCEED')}} </p>
        <div class="popover-footer">
          <Button type="text" size="mini" @click="showConfirmationBox=false">
            {{$t('INDENT_NO')}}
          </Button>
          <Button type="primary" size="mini" @click="saveDropoffDetails">
            {{$t('INDENT_YES_PROCEED')}}
          </Button>
        </div>
      </div>
    </div>
    <div v-if="showToggleForApplyToRelatedDrops">
      <SwitchBtn
        label="right"
        size="medium"
        :active-text="$t('APPLY_TO_RELATED_DROPS')"
        :inactive-text="$t('APPLY_TO_RELATED_DROPS')"
        class="default-switch"
        :disabled="disabled || disableToggleForApplyToRelatedDrops"
        v-model="applyToRelatedDrops"
      />
      <p class="mt-0">{{$t('APPLY_TO_RELATED_DROPS_DESCRIPTION')}}</p>
    </div>
    <div class="mb-10" v-if="canMarkDelivery">
      <Radio v-model="deliveryEvent" :label="lastMileEvents.MARK_DELIVERED">
      {{$t('INDENT_MARK_AS_DELIVERED')}}
      </Radio>
      <Radio v-model="deliveryEvent" :label="lastMileEvents.NOT_DELIVERED">
      {{$t('INDENT_NOT_DELIVERED')}}
      </Radio>
    </div>
    <!-- MARK_AS_DELIVERED & MARK_NOT_DELIVERED -->
    <div v-if="deliveryEvent === lastMileEvents.MARK_DELIVERED">
      <span v-if="!canMarkDelivery">
          <div class="last-mile-flex-container">
            <div class="last-mile-row">
              <span class="last-mile-span">
                {{ $t('LAST_MILE_REPORTED_AT') }}&nbsp;:&nbsp;<strong>{{ getFormattedDate(currentDropoff.reported_at) }}</strong>
              </span>
              <span v-if="isShipper" class="last-mile-span">
                {{ $t('LAST_MILE_UNLOADING_START_AT') }}&nbsp;:&nbsp;<strong>{{ getFormattedDate(currentDropoff.unloading_start_at) }}</strong>
              </span>
            </div>
            <div v-if="isShipper" class="last-mile-row">
              <span class="last-mile-span">
                {{ $t('LAST_MILE_UNLOADING_END_AT') }}&nbsp;:&nbsp;<strong>{{ getFormattedDate(currentDropoff.unloading_end_at) }}</strong>
              </span>
              <span class="last-mile-span">
                {{ $t('LAST_MILE_RELEASE_AT') }}&nbsp;:&nbsp;<strong>{{ getFormattedDate(currentDropoff.release_at) }}</strong>
              </span>
            </div>
            <div v-if="currentDropoff.is_cash_collected" class="last-mile-row">
              <span class="last-mile-span">
                {{ $t('INDENT_CASH_COLLECTED') }}&nbsp;:&nbsp;<strong>{{$getIndianFormat(currentDropoff.cash_received)}}</strong>
              </span>
            </div>
            <div class="last-mile-row" v-if="consigneeAttachments.length">
              <span class="last-mile-span">
                {{ $t('INDENT_ATTACHMENTS') }}
                <Attachments
                  class="ml-m15"
                  :disableUpload="true"
                  :attachments="consigneeAttachments"
                  :showPreview="true"
                  :disableDelete="true">>
                </Attachments>
              </span>
            </div>
          </div>
      </span>
      <Row v-else>
        <Col :lg="24" :md="24">
          <Form :inline="true" class="form-default form-triple mt-15">
            <FormItem :inline="true" :label="$t('INDENT_REPORTED_AT')" :disabled="disabled || isAutoReached">
              <DatePicker v-model="arrived"
                type="datetime"
                :picker-options="arrivedOption"
                :format="datePickerFormat"
                :placeholder="$t('INDENT_SELECT_DATE_AND_TIME')"
                :disabled="disabled || isAutoReached"
                @input="onArrived"
                :clearable="(currentDropoff.reported_at && !currentDropoff.is_not_delivered) ? false:true"
                :default-time="defaultTime"
                :prefix-icon="isArrivedGeofenceDatePopulated"
                class="w175">
              </DatePicker>
            </FormItem>
            <FormItem v-if="isShipper" :inline="true" :label="$t('INDENT_UNLODING_START_AT')" :disabled="disabled">
              <DatePicker v-model="unloadingStart"
                type="datetime"
                :picker-options="arrivedOption"
                :format="datePickerFormat"
                :placeholder="this.$t('INDENT_SELECT_DATE_AND_TIME')"
                :disabled="disabled || isAutoReached"
                :clearable="(this.currentDropoff.unloading_start_at && !currentDropoff.is_not_delivered) ? false:true"
                :default-time="defaultTime"
                :prefix-icon="isArrivedGeofenceDatePopulated"
                @input="onUnloadingStart"
                class="w175">
              </DatePicker>
            </FormItem>
            <FormItem v-if="isShipper" :inline="true" :label="$t('INDENT_UNLOADING_END_AT')" :disabled="disabled">
              <DatePicker v-model="unloadingEnd"
                type="datetime"
                :picker-options="releaseOption"
                :format="datePickerFormat"
                :placeholder="this.$t('INDENT_SELECT_DATE_AND_TIME')"
                :disabled="disabled || isAutoReached"
                :clearable="(this.currentDropoff.unloading_end_at && !currentDropoff.is_not_delivered) ? false:true"
                :default-time="defaultTime"
                :prefix-icon="isDispatchedGeofenceDatePopulated"
                @input="onUnloadingEnd"
                class="w175">
              </DatePicker>
            </FormItem>
            <FormItem :inline="true" :label="$t('INDENT_POD_DATE')" :disabled="disabled || disableIfLRNotAvailable">
              <DatePicker v-model="dispatched"
              type="datetime"
              :picker-options="releaseOption"
              :format="datePickerFormat"
              :placeholder="this.$t('INDENT_SELECT_DATE_AND_TIME')"
              :disabled="disabled || disableIfLRNotAvailable"
              :clearable="(this.currentDropoff.release_at && !currentDropoff.is_not_delivered) ? false:true"
              :default-time="defaultTime"
              :prefix-icon="isDispatchedGeofenceDatePopulated"
              @input="onDispatched"
              class="w175">
              </DatePicker>
            </FormItem>
          </Form>
          <div class="mt-10">
            <div class="list-form-switch d-inline mr-30">
              <label class="text-sm text-nowrap w-auto">{{ $t('INDENT_CASH_RECEIVED_ON_HAND') }}</label>
              <SwitchBtn :disabled="disabled" v-model="isCashCollected" @change="onToggleSwitch($event)" label="right" size="small"/>
            </div>
            <Form v-if="isCashCollected" :inline="true" class="form-default form-triple mt-5">
              <FormItem :label="$t('INDENT_CASH_COLLECTED')" :disabled="disabled">
                <Input type="number" :placeholder="$t('INDENT_ENTER_CASH_COLLECTED')" @input="onCashReceived" v-model="cashReceived"></Input>
              </FormItem>
            </Form>
          </div>
          <div class="list-form-switch mt-10">
            <label class="text-sm text-nowrap w-auto">{{ $t('INDENT_ATTACHMENTS') }}</label>
              <Attachments
                class="ml-m15"
                :disableUpload="false"
                :attachments="consigneeAttachments"
                :showPreview="true"
                :disableDelete="true"
                @addAttachments="addAttachments">
              </Attachments>
          </div>
        </Col>
      </Row>
      <div style="margin-top: 10px;">
        <strong>{{  $t('ADMIN_NOTE').toUpperCase() }}: </strong>
        &nbsp;{{ $t('INDENT_REPORTED_POD_TIME_DEFAULTS_TO_GEO_FENCE_TIME') }}
      </div>
    </div>
    <div v-else>
      <span v-if="currentDropoff.is_not_delivered">
          <div class="last-mile-flex-container">
            <div class="last-mile-row">
              <span class="last-mile-span">
                {{ $t('LAST_MILE_REPORTED_AT') }}&nbsp;:&nbsp;<strong>{{ getFormattedDate(currentDropoff.reported_at) }}</strong>
              </span>
              <span class="last-mile-span">
                {{ $t('INDENT_REASON') }}&nbsp;:&nbsp;<strong>{{ currentDropoff.not_delivered_reason }}</strong>
              </span>
            </div>
            <div class="last-mile-row" v-if="consigneeAttachments.length">
              <span class="last-mile-span">
                {{ $t('INDENT_ATTACHMENTS') }}
                <Attachments
                class="ml-m15"
                :disableUpload="true"
                :attachments="consigneeAttachments"
                :showPreview="true"
                :disableDelete="true">
                </Attachments>
              </span>
            </div>
          </div>
        </span>
      <Row v-else>
        <Col :lg="24" :md="24">
          <Form :inline="true" class="form-default form-triple mt-15">
            <span>
              <FormItem :inline="true" :label="$t('INDENT_REPORTED_AT')" :disabled="disabled || isAutoReached">
                <DatePicker
                  type="datetime"
                  :picker-options="releaseOption"
                  :format="datePickerFormat"
                  :placeholder="this.$t('INDENT_SELECT_DATE_AND_TIME')"
                  :disabled="disabled || isAutoReached"
                  :clearable="this.currentDropoff.unloading_end_at ? false:true"
                  :default-time="defaultTime"
                  :prefix-icon="isDispatchedGeofenceDatePopulated"
                  class="w175"
                  v-model="notDeliveredArrived"
                />
              </FormItem>
            </span>
            <span>
              <FormItem :required="true" :label="$t('INDENT_REASON')" :disabled="disabled || isAutoReached">
                <Select :disabled="disabled || isAutoReached" class="select-default z-index" collapse-tags
                  filterable type="text" v-model="selectedNotDeliveredReason">
                  <Option v-for="(item, index) in notDeliveredReasonList" :key="index" :label="item" :value="item"
                    type="text" />
                </Select>
              </FormItem>
            </span>
            <span v-if="showOtherReasonInput">
              <FormItem :required="true" :label="$t('LAST_MILE_OTHER_REASON')" style="width: 66.66%">
              <Input :placeholder="$t('INDENT_REASON')" type="text" v-model="otherReason"/>
              </FormItem>
            </span>
          </Form>
          <div class="list-form-switch mt-10">
            <label class="text-sm text-nowrap w-auto">{{ $t('INDENT_ATTACHMENTS') }}</label>
              <Attachments
                class="ml-m15"
                :disableUpload="false"
                :attachments="consigneeAttachments"
                :showPreview="true"
                :disableDelete="true"
                @addAttachments="addAttachments">
              </Attachments>
          </div>
        </Col>
      </Row>
      <div :style="{ 'margin-top': '10px' }">
        <strong>{{  $t('ADMIN_NOTE').toUpperCase() }}: </strong>
        &nbsp;{{ $t('INDENT_REPORTED_POD_TIME_DEFAULTS_TO_GEO_FENCE_TIME') }}
      </div>
    </div>
  </div>
</template>

<script>
import { movementMapLower } from 'pando-constants';
import Attachments from '@common/components/Attachments';
import { notDeliveredReasons, lastMileEvents } from '../../../constants/last-mile';
import { oneDayMilliSeconds } from '../../../constants/order';
import MarkAsDelivered from '../actions/MarkAsDelivered';

export default {
  name: 'LastMileDropoffForm',
  components: {
    MarkAsDelivered,
    Attachments,
  },
  props: {
    currentDropoff: {
      type: Object,
      default: () => ({}),
    },
    movement: {
      type: Number,
      default: () => -1,
    },
    order: {
      type: Object,
      default: () => ({}),
    },
    getBackDateConfig: {
      type: Object,
      default: () => ({}),
    },
    datePickerFormat: {
      type: String,
      default: () => 'dd-MM-yyyy hh:mmA',
    },
    currentIndex: {
      type: Number,
      default: () => -1,
    },
    canPerformAction: {
      type: Boolean,
      default: () => true,
    },
    isShipper: {
      type: Boolean,
      default: () => true,
    },
    configurations: {
      type: Object,
      default: () => ({}),
    },
    isLrMandatoryForMarkAsDelivered: {
      type: Object,
      default: () => ({}),
    },
    getEntityDisplayName: {
      type: Function,
      required: true,
    },
    isDatesChanged: {
      type: Function,
      required: true,
    },
    getFormattedDate: {
      type: Function,
      required: true,
    },
    completedPickupsMap: {
      type: Object,
      default: () => ({}),
    },
    yetToBeDeliveredDestinationIds: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.dispatch = this.sourceDispatchDate;
    this.payload.destination_id = this.currentDropoff.location_id;
    this.payload.gate_id = this.currentDropoff.gate_id || null;
    this.resetLocalFormData();
    if (this.arrived) {
      this.onArrived(this.arrived);
    }
    if (this.dispatched) {
      this.onDispatched(this.dispatched);
    }
    if (this.unloadingStart) {
      this.onUnloadingStart(this.unloadingStart);
    }
    if (this.unloadingEnd) {
      this.onUnloadingEnd(this.unloadingEnd);
    }
    if (this.currentDropoff && this.currentDropoff.is_apply_to_related_drops) {
      this.applyToRelatedDrops = this.currentDropoff.is_apply_to_related_drops;
    }
    if (this.order && this.order.destinations) {
      this.sequenceNumberMap = this.order.destinations.reduce((acc, destination) => {
        acc[destination.sequence_number] = destination;
        return acc;
      }, {});
    }
  },
  data() {
    const dispatch = this.currentDropoff.arrived_at;
    const truckDispatched = this.dispatch;
    const reportedDateAllow = this.getBackDateConfig.reported_date;
    const releaseDateAllow = this.getBackDateConfig.release_date;
    const currentDate = new Date();
    return {
      otherReason: '',
      dispatch: null,
      notDeliveredArrived: null,
      unloadingStart: null,
      unloadingEnd: null,
      arrived: null,
      dispatched: null,
      defaultTime: `${currentDate.getHours()}:${currentDate.getMinutes()}:00`,
      notDeliveredReasons,
      selectedNotDeliveredReason: '',
      deliveryEvent: lastMileEvents.MARK_DELIVERED,
      lastMileEvents,
      cashReceived: null,
      isCashCollected: false,
      attachmentList: [],
      applyToRelatedDrops: false,
      sequenceNumberMap: {},
      payload: {
        destination_id: null,
        gate_id: null,
        arrived_at: null,
        dispatched_at: null,
        unloading_start_at: null,
        unloading_end_at: null,
        cash_received: null,
        is_cash_collected: false,
        attachment_ids: [],
      },
      showConfirmationBox: false,
      arrivedOption: {
        disabledDate(time) {
          if (reportedDateAllow) {
            return time.getTime() < Date.now() - oneDayMilliSeconds || time.getTime() > new Date();
          }
          return time.getTime() > Date.now() ||
            time.getTime() < new Date(truckDispatched).getTime() - oneDayMilliSeconds;
        },
      },
      releaseOption: {
        disabledDate(time) {
          if (releaseDateAllow) {
            return time.getTime() < Date.now() - oneDayMilliSeconds || time.getTime() > new Date();
          }
          if (!dispatch) {
            return time.getTime() > Date.now() ||
              time.getTime() < new Date(truckDispatched).getTime() - oneDayMilliSeconds;
          }
          return time.getTime() > new Date() ||
            time.getTime() < new Date(dispatch).getTime() - oneDayMilliSeconds;
        },
      },
    };
  },
  computed: {
    isLastDelivery() {
      let flag = false;
      if (this.yetToBeDeliveredDestinationIds.length) {
        if (this.applyToRelatedDrops) {
          const relatedDrops = this.getRelatedDrops();
          const relatedDropIdsMap = { [this.currentDropoffId]: true };
          relatedDrops.forEach((drop) => {
            relatedDropIdsMap[drop.data.unique_id] = true;
          });
          flag = this.yetToBeDeliveredDestinationIds.every(id => relatedDropIdsMap[id]);
        } else {
          flag = this.yetToBeDeliveredDestinationIds.length === 1 &&
            this.yetToBeDeliveredDestinationIds[0] === this.currentDropoffId.toString();
        }
      }
      return flag;
    },
    canMarkDelivery() {
      return (this.currentDropoff.is_not_delivered || !this.isTruckReleased) &&
        this.$statusUtil.isDispatched(this.order.status);
    },
    consigneeAttachments() {
      return this.attachmentList || [];
    },
    depotName() {
      return this.isShipper ? this.currentDropoff.details.name : this.currentDropoff.address.name;
    },
    notDeliveredReasonList() {
      return notDeliveredReasons.map(reason => this.$t(reason));
    },
    showOtherReasonInput() {
      return this.selectedNotDeliveredReason === this.$t('LAST_MILE_OTHER_REASON');
    },
    currentDropoffId() {
      return this.isShipper ? this.currentDropoff.unique_id : this.currentDropoff._id;
    },
    sourceDispatchDate() {
      const sourceDetails = this.order.sources.find(source =>
        source.location_id === this.currentDropoff.source_location_id &&
        (source.gate_id ? source.gate_id === this.currentDropoff.source_gate_id : true));
      return sourceDetails ? this.$moment(sourceDetails.dispatched_at) : null;
    },
    isTruckReleased() {
      return !!this.currentDropoff.release_at;
    },
    getGeofenceReportedAt() {
      return this.configurations.autopopulate_geofence_time ?
        this.currentDropoff.geofence_entry_time : null;
    },
    getGeofenceDispatchedAt() {
      return this.configurations.autopopulate_geofence_time ?
        this.currentDropoff.geofence_exit_time : null;
    },
    disableIfLRNotAvailable() {
      const currentDropoffHasLrAttachment = !!(this.currentDropoff.lr_attachment_ids && this.currentDropoff.lr_attachment_ids.length);
      const lrObject = this.order.lorry_receipt
        .find(lr => lr.destination_location_id === this.currentDropoff.location_id);
      const hasLrAttachment = lrObject ? lrObject.document_available : false;
      return this.isLrMandatoryForMarkAsDelivered && this.movement && movementMapLower[this.movement] &&
        this.isLrMandatoryForMarkAsDelivered[movementMapLower[this.movement]] &&
        !(currentDropoffHasLrAttachment || hasLrAttachment);
      // Have used both the variables to check lr attachment
      // so that for all lorry_receipt_generate_category this should work
    },
    disabled() {
      return !this.canPerformAction;
    },
    allowReportedToBackDate() {
      return this.getBackDateConfig.reported_date;
    },
    allowReleaseToBackDate() {
      return this.getBackDateConfig.release_date;
    },
    isAutoReached() {
      // based on geofence, only when consignee_auto_reach_release flag is enabled in client settings
      const trackSetting = this.configurations.track_settings;
      if (trackSetting && trackSetting.consignee_auto_reach) {
        return !!(this.currentDropoff.geofence_entry_time);
      }
      return false;
    },
    isGeofenceDatePopulated() {
      if (this.configurations.autopopulate_geofence_time) {
        if (((!this.currentDropoff.reported_at && !!this.currentDropoff.geofence_entry_time) ||
           (!this.currentDropoff.release_at && !!this.currentDropoff.geofence_exit_time))) {
          if (new Date(this.arrived).getTime() === new Date(this.currentDropoff.geofence_entry_time).getTime() ||
              new Date(this.dispatched).getTime() === new Date(this.currentDropoff.geofence_exit_time).getTime()) {
            return true;
          }
        }
      }
      return false;
    },
    isArrivedGeofenceDatePopulated() {
      if (this.configurations.autopopulate_geofence_time) {
        if ((!this.currentDropoff.reported_at && !!this.currentDropoff.geofence_entry_time)) {
          if (new Date(this.arrived).getTime() === new Date(this.currentDropoff.geofence_entry_time).getTime()) {
            return 'icon-location';
          }
        }
      }
      return 'el-icon-date';
    },
    isDispatchedGeofenceDatePopulated() {
      if (this.configurations.autopopulate_geofence_time) {
        if ((!this.currentDropoff.release_at && !!this.currentDropoff.geofence_exit_time)) {
          if (new Date(this.dispatched).getTime() === new Date(this.currentDropoff.geofence_exit_time).getTime()) {
            return 'icon-location';
          }
        }
      }
      return 'el-icon-date';
    },
    enableSaveButton() {
      if (!this.canPerformAction) return false;
      if (this.deliveryEvent === lastMileEvents.NOT_DELIVERED) {
        return (this.isDatesChanged(this.notDeliveredArrived, this.currentDropoff.reported_at) ||
          this.selectedNotDeliveredReason !== this.currentDropoff.not_delivered_reason) && !!this.notDeliveredArrived &&
          (this.showOtherReasonInput ? !!this.otherReason : true) && !this.currentDropoff.is_not_delivered;
      }
      // when 'mark as delivered' is done after 'not delivered'
      let currentDropDetails = this.currentDropoff;
      if (this.currentDropoff.is_not_delivered) {
        currentDropDetails = {};
      }
      const isReportedAtChanged = this.isDatesChanged(this.payload.reported_at,
        currentDropDetails.reported_at);
      const isUnloadingStartChanged = this.isDatesChanged(this.payload.unloading_start_at,
        currentDropDetails.unloading_start_at);
      const isUnloadingEndChanged = this.isDatesChanged(this.payload.unloading_end_at,
        currentDropDetails.unloading_end_at);
      const isReleaseAtChanged = this.isDatesChanged(this.payload.release_at,
        currentDropDetails.release_at);
      const isCashReceived = (this.payload.cash_received || 0) !== (currentDropDetails.cash_received || 0);
      const isCashCollected = (this.payload.is_cash_collected || false) !== (currentDropDetails.is_cash_collected || false);
      return (isReportedAtChanged || isUnloadingEndChanged || isUnloadingStartChanged ||
        isReleaseAtChanged || isCashCollected || isCashReceived) && this.canMarkDelivery;
    },
    disableToggleForApplyToRelatedDrops() {
      return this.canPerformAction && (this.arrived || this.notDeliveredArrived);
    },
    showToggleForApplyToRelatedDrops() {
      let showToggle = false;
      if (this.order && this.order.destinations) {
        if (this.currentDropoff.is_apply_to_related_drops) {
          showToggle = true;
        } else {
          const nextSequence = this.currentDropoff.sequence_number + 1;
          const sequenceNumbers = Object.keys(this.sequenceNumberMap);
          if (nextSequence && sequenceNumbers.includes(nextSequence.toString())) {
            showToggle = true;
          }
          const currentDestinationKey = `${this.currentDropoff.location_id}_${this.currentDropoff.gate_id || ''}`;
          const nextDestination = this.sequenceNumberMap[nextSequence];
          if (nextDestination) {
            const nextDestinationDropoffKey = `${nextDestination.location_id}_${nextDestination.gate_id || ''}`;
            const isPickupCompleted = !!this.completedPickupsMap[`${nextDestination.source_location_id}_${nextDestination.source_gate_id || ''}`];
            if ((currentDestinationKey !== nextDestinationDropoffKey)
              || nextDestination.reported_at
              || !isPickupCompleted) {
              showToggle = false;
            }
          }
        }
      }
      return showToggle;
    },
  },
  methods: {
    async attachmentCall(file) {
      try {
        const formData = new FormData();
        formData.append('attachment', file.raw);
        const method = this.isShipper ? 'order/addAttachment' : 'indents/addAttachment';
        const result = await this.$store.dispatch(
          method,
          formData,
        );
        return result;
      } catch (err) {
        const apiError = err && err.data && (err.data.messages || (err.data.errors && err.data.errors[0] && err.data.errors[0].messages));
        this.$error({ message: apiError || this.$getErr('APP_CATCH_ERR') });
      }
      return null;
    },
    async addAttachments(file) {
      const result = await this.attachmentCall(file);
      if (result && result.error) {
        this.$error({ message: this.$t('INDENT_UPLOAD_FAILED') });
      } else {
        const attachmentObj = {
          id: result.id,
          url: result.attachment_url,
        };
        this.attachmentList.push(attachmentObj);
        this.payload.attachment_ids.push(result.id);
        // Auto-save when attachment is uploaded        
        this.saveDropoffDetails(true);
      }
    },
    onUnloadingEnd(date) {
      this.unloadingEnd = date;
      this.payload.unloading_end_at = date;
    },
    onUnloadingStart(date) {
      this.unloadingStart = date;
      this.payload.unloading_start_at = date;
    },
    onArrived(date) {
      this.arrived = date;
      this.payload.reported_at = this.arrived;
      if (!this.payload.release_at && !this.currentDropoff.is_not_delivered) {
        this.payload.release_at = this.currentDropoff.release_at ? new Date(this.currentDropoff.release_at) : null;
      }
      if (!this.unloadingStart || isNaN(this.unloadingStart) || this.allowReleaseToBackDate || date) {
        this.unloadingStart = this.$hasFeature('should_not_auto_populate_milestone_fields') ? this.unloadingStart : date;
        this.payload.unloading_start_at = this.unloadingStart;
      }
      this.payload.geofence_populated = this.isGeofenceDatePopulated;
    },
    onDispatched(date) {
      this.dispatched = date;
      this.payload.release_at = (this.allowReleaseToBackDate) ? new Date() : date;
      if (!this.payload.reported_at && !this.currentDropoff.is_not_delivered) {
        this.payload.reported_at = this.currentDropoff.reported_at ? new Date(this.currentDropoff.reported_at) : null;
      }
      if (!this.unloadingEnd || isNaN(this.unloadingEnd) || this.allowReleaseToBackDate || date) {
        this.unloadingEnd = this.dispatched;
        this.payload.unloading_end_at = this.payload.release_at;
      }
      this.payload.geofence_populated = this.isGeofenceDatePopulated;
    },
    onCashReceived() {
      this.payload.cash_received = Number(this.cashReceived);
    },
    onToggleSwitch(event) {
      this.payload.is_cash_collected = event;
    },
    fillReportedAt() {
      if (this.currentDropoff.reported_at) {
        return new Date(this.currentDropoff.reported_at);
      }
      if (this.getGeofenceReportedAt) {
        return new Date(this.currentDropoff.geofence_entry_time);
      }
      return null;
    },
    fillDispatchedAt() {
      if (this.currentDropoff.release_at) {
        return new Date(this.currentDropoff.release_at);
      }
      if (this.getGeofenceDispatchedAt) {
        return new Date(this.currentDropoff.geofence_exit_time);
      }
      return null;
    },
    getPickerOptions() {
      const truckDispatched = this.dispatch;
      const getBackDateConfig = this.getBackDateConfig;
      return {
        disabledDate(time) {
          if (getBackDateConfig.reported_date) {
            return time.getTime() < Date.now() - oneDayMilliSeconds || time.getTime() > new Date();
          }
          return time.getTime() > Date.now() ||
              time.getTime() < new Date(truckDispatched).getTime() - oneDayMilliSeconds;
        },
      };
    },
    prepareData() {
      let data = null;
      if (this.deliveryEvent === lastMileEvents.NOT_DELIVERED) {
        const reason = this.showOtherReasonInput ? this.otherReason : this.selectedNotDeliveredReason;
        const reportedAt = this.notDeliveredArrived;
        const payload = this.payload;
        data = {
          is_not_delivered: true,
          not_delivered_reason: reason,
          reported_at: reportedAt,
          destination_id: payload.destination_id,
          ...(payload.gate_id) ? { gate_id: payload.gate_id } : {},
        };
      } else {
        data = Object.keys(this.payload).reduce((acc, key) => {
          if (this.payload[key] || key === 'is_cash_collected') {
            acc[key] = this.payload[key];
          }
          return acc;
        }, {});
      }
      data.unique_id = this.currentDropoffId;
      data.is_apply_to_related_drops = this.applyToRelatedDrops;
      data.is_delivery_action = true;
      if (this.payload.attachment_ids) {
        data.attachment_ids = this.payload.attachment_ids;
      }
      return data;
    },

    saveDropoffDetails(performAction = true) {
      if (!performAction && this.deliveryEvent === lastMileEvents.NOT_DELIVERED && this.isLastDelivery) {
        this.showConfirmationBox = true;
        return;
      }
      this.showConfirmationBox = false;
      const data = this.prepareData();
      const collectionAmount = (this.currentDropoff && this.currentDropoff.collection_amount) || 0;
      if (!data.is_not_delivered) {
        if (new Date(data.reported_at).getTime() > new Date().getTime() ||
            new Date(data.release_at).getTime() > new Date().getTime()) {
          this.$errorMessage({ message: this.$t('INDENT_REPORTED_RELEASE_FUTURE_TIME_ERROR_MSG') });
          return;
        }
        if (data.reported_at < this.dispatch) {
          this.$errorMessage({ message: this.$t('INDENT_REPORTED_AFTER_DISPATCHED_ERROR_MSG') });
          return;
        }
        if (data.release_at < data.reported_at) {
          this.$errorMessage({ message: this.$t('INDENT_RELEASE_AFTER_REPORTED_ERROR_MSG') });
          return;
        }
        if (data.unloading_start_at > data.release_at ||
            data.unloading_start_at < data.reported_at) {
          this.$errorMessage({ message: this.$t('INDENT_UNLOADING_START_BTWN_REPORTED_RELEASE') });
          return;
        }
        if (data.unloading_end_at < data.unloading_start_at ||
            data.unloading_end_at > data.release_at) {
          this.$errorMessage({ message: this.$t('INDENT_UNLOADING_END_BTWN_UNLOADING_START_RELEASE') });
          return;
        }
        if (collectionAmount && data.reported_at && data.release_at
          && data.unloading_start_at && data.unloading_end_at && !data.is_cash_collected) {
          this.$errorMessage({ message: this.$t('INDENT_ENTER_CASH_COLLECTED') });
          return;
        }
        if (data.is_cash_collected && !data.cash_received) {
          this.$errorMessage({ message: this.$t('INDENT_ENTER_CASH_COLLECTED') });
          return;
        }
        if (data.cash_received < 0) {
          this.$errorMessage({ message: this.$t('INDENT_ENTER_VALID_AMOUNT') });
          return;
        }
      } else if (data.reported_at < this.dispatch) {
        this.$errorMessage({ message: this.$t('INDENT_REPORTED_AFTER_DISPATCHED_ERROR_MSG') });
        return;
      }
      const drops = [{
        data,
        name: this.getEntityDisplayName(this.currentDropoff),
      }];
      if (this.applyToRelatedDrops) {
        drops.push(...this.getRelatedDrops());
      }
      this.$emit('multiple-mark-as-delivered', drops);
    },
    getRelatedDrops() {
      const currentDestinationKey = `${this.currentDropoff.location_id}_${this.currentDropoff.gate_id || ''}`;
      let nextSequence = this.currentDropoff.sequence_number + 1;
      const relatedDrops = [];
      let canCheckNextDrop = true;
      while (canCheckNextDrop && this.sequenceNumberMap && this.sequenceNumberMap[nextSequence]) {
        const destination = this.sequenceNumberMap[nextSequence];
        const nextDestinationDropoffKey = `${destination.location_id}_${destination.gate_id || ''}`;
        const isPickupCompleted = !!this.completedPickupsMap[`${destination.source_location_id}_${destination.source_gate_id || ''}`];
        const isApplyToRelatedDropPresent = destination.is_apply_to_related_drops;
        if (!isApplyToRelatedDropPresent) {
          if ((currentDestinationKey === nextDestinationDropoffKey) && isPickupCompleted) {
            let data;
            if (this.deliveryEvent === lastMileEvents.NOT_DELIVERED) {
              const reason = this.showOtherReasonInput ? this.otherReason : this.selectedNotDeliveredReason;
              const reportedAt = this.notDeliveredArrived;
              data = {
                is_not_delivered: true,
                not_delivered_reason: reason,
                reported_at: reportedAt,
                destination_id: this.payload.destination_id,
                unique_id: this.isShipper ? destination.unique_id : destination._id,
                ...(this.payload.gate_id) ? { gate_id: this.payload.gate_id } : {},
              };
            } else {
              const cashReceived = this.cashReceived || this.payload.cash_received;
              const cashCollected = this.isCashCollected || this.payload.is_cash_collected;
              const reportedAt = this.payload.reported_at;
              data = {
                destination_id: destination.location_id,
                unique_id: this.isShipper ? destination.unique_id : destination._id,
                ...this.payload.unloading_start_at ? { unloading_start_at: this.payload.unloading_start_at } : {},
                ...reportedAt ? { reported_at: reportedAt } : {},
                ...this.payload.unloading_end_at ? { unloading_end_at: this.payload.unloading_end_at } : {},
                ...this.payload.release_at ? { release_at: this.payload.release_at } : {},
                ...cashReceived ? { cash_received: cashReceived } : {},
                ...cashCollected ? { is_cash_collected: cashCollected } : {},
              };
            }
            if (this.payload.attachment_ids) {
              data.attachment_ids = this.payload.attachment_ids;
            }
            relatedDrops.push({
              data,
              name: this.getEntityDisplayName(destination),
            });
          } else {
            canCheckNextDrop = false;
          }
        } else {
          canCheckNextDrop = false;
        }
        nextSequence += 1;
      }
      return relatedDrops;
    },
    cancelChanges() {
      this.$emit('cancel');
      this.resetLocalFormData();
    },
    resetLocalFormData() {
      if (this.currentDropoff.is_not_delivered) {
        this.deliveryEvent = this.lastMileEvents.NOT_DELIVERED;
        this.notDeliveredArrived = new Date(this.currentDropoff.reported_at);
        if (notDeliveredReasons.includes(this.currentDropoff.not_delivered_reason)) {
          this.selectedNotDeliveredReason = this.currentDropoff.not_delivered_reason;
        } else {
          this.selectedNotDeliveredReason = this.$t('LAST_MILE_OTHER_REASON');
          this.otherReason = this.currentDropoff.not_delivered_reason;
        }
        this.arrived = null;
        this.dispatched = null;
        this.unloadingStart = null;
        this.unloadingEnd = null;
        this.cashReceived = null;
        this.isCashCollected = false;
      } else {
        this.notDeliveredArrived = null;
        this.selectedNotDeliveredReason = this.$t(this.notDeliveredReasons[0]);
        this.arrived = this.fillReportedAt();
        this.dispatched = this.fillDispatchedAt();
        this.unloadingStart = this.currentDropoff.unloading_start_at || this.arrived;
        this.unloadingEnd = this.currentDropoff.unloading_end_at || this.dispatched;
        this.cashReceived = this.currentDropoff.cash_received;
        this.isCashCollected = this.currentDropoff.is_cash_collected;
      }
      this.payload.reported_at = this.arrived;
      this.payload.unloading_start_at = this.unloadingStart;
      this.payload.release_at = this.dispatched;
      this.payload.unloading_end_at = this.unloadingEnd;
      this.payload.cash_received = this.cashReceived;
      this.payload.is_cash_collected = this.isCashCollected;
      this.payload.attachment_ids = (this.currentDropoff
       && this.currentDropoff.attachments.map(attachment => attachment.id)) || [];
      this.attachmentList = this.currentDropoff.attachments || [];
    },
  },
  watch: {
    currentDropoff() {
      this.arrived = (this.currentDropoff && this.currentDropoff.reported_at)
        ? new Date(this.currentDropoff.reported_at) : this.arrived;
      this.dispatched = (this.currentDropoff && this.currentDropoff.release_at)
        ? new Date(this.currentDropoff.release_at) : this.dispatched;
      this.unloadingStart = (this.currentDropoff && this.currentDropoff.unloading_start_at)
        ? new Date(this.currentDropoff.unloading_start_at) : this.unloadingStart;
      this.unloadingEnd = (this.currentDropoff && this.currentDropoff.unloading_end_at)
        ? new Date(this.currentDropoff.unloading_end_at) : this.unloadingEnd;
    },
  },
};
</script>

<style lang="scss" scoped>
.last-mile-f-right {
  position: absolute;
  top: 60px;
  right: 0px;
}

.warning-text {
  font-size: medium;
  color: #234357;
  font-weight: bold;
  letter-spacing: 0.5px;
}
</style>

